/* Far & Away 'True Cost of Cheap Plates' landing page (native rebuild of the Replo page /pages/true-cost).
   Hooks: data-tc-* only.
   1. LEARN MORE buttons: smooth scroll to their target (Replo scrollToUrlHashmark, offset 0).
   2. Comparison amounts in every presentment currency other than the store currency (GBP included; the
      server's GBP 69 is only the no-JS fallback): the store-currency base of the mass-produced set is
      converted at Shopify.currency.rate (the rate the bundles page uses for its delivery thresholds) and
      rounded to a whole unit; YEAR 5 is 4 x that amount. The number format is read from a server-rendered
      money_without_trailing_zeros sample in the active currency, so these amounts read like the Far & Away
      price next to them. */
(function () {
  'use strict';
  function all(sel, scope) { return Array.prototype.slice.call((scope || document).querySelectorAll(sel)); }

  function initScroll() {
    all('[data-tc-scroll]').forEach(function (btn) {
      if (btn.__tc) return; btn.__tc = true;
      var go = function (e) {
        var target = document.querySelector(btn.getAttribute('data-tc-scroll'));
        if (!target) return;
        if (e) e.preventDefault();
        // The page scrolls on the window, except where the theme makes <body> the scroll container (the US
        // theme renders in quirks mode with body{overflow-y:auto;height:100%}); scroll whichever ancestor scrolls.
        var scroller = null;
        for (var el = target.parentElement; el; el = el.parentElement) {
          var oy = getComputedStyle(el).overflowY;
          if ((oy === 'auto' || oy === 'scroll') && el.scrollHeight > el.clientHeight + 1) { scroller = el; break; }
        }
        if (!scroller || scroller === document.documentElement || scroller === document.scrollingElement) {
          var top = target.getBoundingClientRect().top + window.pageYOffset;
          try { window.scrollTo({ top: top, behavior: 'smooth' }); } catch (err) { window.scrollTo(0, top); }
        } else {
          var y = scroller.scrollTop + target.getBoundingClientRect().top - (scroller === document.body ? 0 : scroller.getBoundingClientRect().top);
          try { scroller.scrollTo({ top: y, behavior: 'smooth' }); } catch (err) { scroller.scrollTop = y; }
        }
      };
      btn.addEventListener('click', go);
      btn.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') go(e); });
    });
  }

  // "123.456.789 zł" / "CHF 1,234,567" / "€1.234.567" (sample = 1234567 whole units) -> formatter for whole units
  function formatter(sample) {
    var m = sample && sample.match(/1(\D?)234(\D?)567/);
    if (!m) return null;
    var sep = m[1] || m[2] || '';
    var before = sample.slice(0, m.index), after = sample.slice(m.index + m[0].length);
    after = after.replace(/^[.,]0+/, '');
    return function (n) {
      var s = String(n);
      if (sep) s = s.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
      return before + s + after;
    };
  }

  function initCurrency() {
    all('[data-tc-convert]').forEach(function (section) {
      var cur = window.Shopify && window.Shopify.currency;
      var rate = cur ? parseFloat(cur.rate) : NaN;
      if (!cur || !cur.active || !(rate > 0)) return;
      if (cur.active === section.getAttribute('data-tc-shop-currency')) return;
      var base = parseFloat(section.getAttribute('data-tc-base'));
      var fmt = formatter(section.getAttribute('data-tc-money-sample'));
      if (!(base > 0) || !fmt) return;
      var one = Math.round(base * rate);
      all('[data-tc-mp]', section).forEach(function (el) {
        // the "+" stays in the same text node as the amount (a separate node changes the glyph spacing)
        el.textContent = (el.getAttribute('data-tc-prefix') || '') + fmt(one * parseInt(el.getAttribute('data-tc-mp'), 10)) + (el.getAttribute('data-tc-suffix') || '');
      });
      section.setAttribute('data-tc-converted', cur.active + ' ' + rate);
    });
  }

  function init() { initScroll(); initCurrency(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
